<template>
  <Fragment>
    <div class="eu-flex-item eu-basis_6">
      <p class="emd-text _color_subtle _type_caption eu-mb_1">
        {{ $t('charge.detail.payment-method.boleto.our-number') }}
      </p>
      <p class="emd-card-grid__line">{{ nossoNumero || '-' }}</p>
    </div>
    <div class="eu-flex-item eu-basis_6">
      <p class="emd-text _color_subtle _type_caption eu-mb_1">
        {{ $t('charge.detail.payment-method.boleto.document-number') }}
      </p>
      <p class="emd-card-grid__line">{{ documentNumber || '-' }}</p>
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
export default {
  name: 'ChargesPaymentMethodBoletoDetail',
  components: {
    Fragment
  },
  props: {
    nossoNumero: { required: true },
    documentNumber: { required: true }
  }
}
</script>
